import { Card, Divider, Space, Typography } from "antd"
import React, { type ReactNode } from "react"

const { Title } = Typography

interface ProjectSectionCardProps {
  title?: string
  divider?: boolean
  children: ReactNode
}

export function ProjectSectionCard({
  title,
  divider,
  children
}: ProjectSectionCardProps) {
  return (
    <Card size={"small"} className={"w-full h-fit"}>
      <Space direction={"vertical"} className={"w-full"}>
        {title && (
          <Title className={divider ? "mb-0" : ""} level={4}>
            {title}
          </Title>
        )}
        {divider && <Divider className={"my-1"} />}
        {children}
      </Space>
    </Card>
  )
}
